import { FaWindowClose } from "react-icons/fa";

const CloseButton = ({ handleClick, className }: { handleClick: () => void; className: string }) => {
  return (
    <div onClick={handleClick} className={className}>
      <FaWindowClose
        size={22}
        className="cursor-pointer rounded-sm border border-zinc-50 text-red-400"
      />
    </div>
  );
};

export { CloseButton };
